
















































import Vue from 'vue'

import Task from './Task'
import Timer from './Timer'

export default Vue.extend({
  components: {
    Task,
    Timer,
  },
  props: {
    after: {
      type: String,
    },
    timer: {
      type: String,
    },
    task: {
      type: String,
    },
  },
})
